import { UiSchema } from "@rjsf/utils";
import { CustomArrayFieldItemTemplate } from "../templates/DependentArrayFieldItemTemplate";

export const groupInfoUiSchema: UiSchema = {};

export const primaryInfoUiSchema: UiSchema = {
  ssn: {
    "ui:widget": "password",
  },
};

export const coverageSelectionUiSchema: UiSchema = {};

export const dependentInfoUiSchema: UiSchema = {
  "ui:definitions": {
    "#/definitions/dependent": {
      ssn: {
        "ui:widget": "password",
      },
    },
  },
  dependents: {
    "ui:ArrayFieldItemTemplate": CustomArrayFieldItemTemplate,
    "ui:options": {
      orderable: false,
      addable: true,
    },
  },
};
